export const readAllNotifications = 'Marcar como leídas'
export const notificationsTitle = 'NOTIFICACIONES'
export const youDontHaveNew = 'No tiene notificaciones nuevas'
export const changeNotificationsReading =
  'Estás a punto de marcar todas las notificaciones como leídas. Ya no volverás a ver estas notificaciones en el menú'
